"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIFieldset = _interopRequireDefault(require("UIComponents/form/UIFieldset"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _link = require("../../constants/link");

var _LinkFields = _interopRequireDefault(require("./LinkFields"));

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links." + suffix;
};

var EditLinkPopoverControls =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(EditLinkPopoverControls, _Component);

  function EditLinkPopoverControls() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, EditLinkPopoverControls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(EditLinkPopoverControls)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleLinkTextChange = function (_ref) {
      var value = _ref.target.value;

      _this.props.onUpdate({
        linkText: value
      });
    };

    return _this;
  }

  (0, _createClass2.default)(EditLinkPopoverControls, [{
    key: "renderLinkTextInput",
    value: function renderLinkTextInput() {
      var _this$props = this.props,
          linkText = _this$props.linkText,
          canModifyLinkText = _this$props.canModifyLinkText;
      if (!canModifyLinkText) return null;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes.linkText.label")),
        className: "m-bottom-1"
      }, _react.default.createElement(_UITextInput.default, {
        autoFocus: canModifyLinkText,
        "data-test-id": "link-text-input",
        value: linkText,
        onChange: this.handleLinkTextChange,
        placeholder: _I18n.default.text(i18nKey('linkTypes.linkText.placeholder'))
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClose = _this$props2.onClose,
          externalLink = _this$props2.externalLink,
          noFollow = _this$props2.noFollow,
          href = _this$props2.href,
          onUpdate = _this$props2.onUpdate,
          onLinkTypeChange = _this$props2.onLinkTypeChange,
          fetchPages = _this$props2.fetchPages,
          fetchMeetings = _this$props2.fetchMeetings,
          fetchAnchors = _this$props2.fetchAnchors,
          linkType = _this$props2.linkType,
          onSelectFile = _this$props2.onSelectFile,
          onUrlKeyDown = _this$props2.onUrlKeyDown,
          currentFileMeta = _this$props2.currentFileMeta,
          showRefAndTargetControls = _this$props2.showRefAndTargetControls,
          useEmailSubscription = _this$props2.useEmailSubscription,
          allowFileDownload = _this$props2.allowFileDownload,
          allowMeetingLink = _this$props2.allowMeetingLink,
          allowAnchorLinks = _this$props2.allowAnchorLinks,
          dropdownClassName = _this$props2.dropdownClassName,
          scopes = _this$props2.scopes,
          userId = _this$props2.userId;
      return _react.default.createElement("div", null, _react.default.createElement(_UICloseButton.default, {
        onClick: onClose,
        color: _colors.EERIE,
        className: "hs-close-button"
      }), _react.default.createElement(_UIFieldset.default, {
        className: "link-popover-edit small-popover-body m-top-3 m-bottom-1 m-x-2",
        _size: "small"
      }, _react.default.createElement("h4", {
        className: "m-bottom-2 m-right-5"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('editLink')
      })), this.renderLinkTextInput(), _react.default.createElement(_LinkFields.default, {
        dropdownClassName: dropdownClassName,
        externalLink: externalLink,
        noFollow: noFollow,
        href: href,
        onUpdate: onUpdate,
        onLinkTypeChange: onLinkTypeChange,
        fetchPages: fetchPages,
        fetchMeetings: fetchMeetings,
        fetchAnchors: fetchAnchors,
        linkType: linkType,
        onSelectFile: onSelectFile,
        onUrlKeyDown: onUrlKeyDown,
        showRefAndTargetControls: showRefAndTargetControls,
        currentFileMeta: currentFileMeta,
        useEmailSubscription: useEmailSubscription,
        allowFileDownload: allowFileDownload,
        allowMeetingLink: allowMeetingLink,
        allowAnchorLinks: allowAnchorLinks,
        scopes: scopes,
        userId: userId
      })));
    }
  }]);
  return EditLinkPopoverControls;
}(_react.Component);

exports.default = EditLinkPopoverControls;
EditLinkPopoverControls.propTypes = {
  externalLink: _react.PropTypes.bool.isRequired,
  noFollow: _react.PropTypes.bool.isRequired,
  linkText: _react.PropTypes.string.isRequired,
  canModifyLinkText: _react.PropTypes.bool,
  href: _react.PropTypes.string.isRequired,
  onUpdate: _react.PropTypes.func.isRequired,
  onLinkTypeChange: _react.PropTypes.func.isRequired,
  onUrlKeyDown: _react.PropTypes.func.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  fetchPages: _react.PropTypes.func.isRequired,
  fetchMeetings: _react.PropTypes.func.isRequired,
  fetchAnchors: _react.PropTypes.func.isRequired,
  linkType: _react.PropTypes.oneOf((0, _link.getAllLinkTypesForProps)()).isRequired,
  onSelectFile: _react.PropTypes.func.isRequired,
  showRefAndTargetControls: _react.PropTypes.bool.isRequired,
  currentFileMeta: _react.PropTypes.object,
  dropdownClassName: _react.PropTypes.string,
  useEmailSubscription: _react.PropTypes.bool,
  allowFileDownload: _react.PropTypes.bool,
  allowMeetingLink: _react.PropTypes.bool,
  allowAnchorLinks: _react.PropTypes.bool,
  scopes: _react.PropTypes.array,
  userId: _react.PropTypes.number
};
EditLinkPopoverControls.defaultProps = {
  canModifyLinkText: false,
  linkText: ''
};
module.exports = exports.default;